import React from 'react';
import { Alert } from '@brokerbay/design-components';
import { SUPPORT_EMAIL } from 'utils/constants';

const ProfileExistsAlert: React.FC = () => (
    <Alert
      type="warning"
      message={
        <>
          It looks like an account for you has already been created in
          BrokerBay. Please try inputting your member number on the previous
          screen or email us at{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> for help.
        </>
      }
    />
  );

export default ProfileExistsAlert;
